//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import actHeader from './act-header/act-header.vue';
import redPacket from './red-packet/red-packet.vue';
import luckyBag from './lucky-bag/lucky-bag.vue';
import openVip from './open-vip/open-vip.vue';
import videoList from './video-list/video-list.vue';
import goldBelt from './gold-belt/gold-belt.vue';
import marquee from './marquee/marquee.vue'; // import funnyPark from '@/components/funny-park/funny-park.vue'

export default {
  components: {
    actHeader: actHeader,
    redPacket: redPacket,
    luckyBag: luckyBag,
    openVip: openVip,
    videoList: videoList,
    goldBelt: goldBelt,
    marquee: marquee // funnyPark,

  },
  data: function data() {
    return {};
  },
  computed: {
    showOpenVip: function showOpenVip() {
      return this.now > new Date(window.setting.开通区域.展示开始时间) && this.now < new Date(window.setting.开通区域.展示结束时间) || this.test === '1';
    }
  }
};